import React from 'react';
import { useHistory } from 'react-router-dom';
import { IVisitorTypeFormValues } from '../form';
import { Container } from 'react-bootstrap';
import { Form, FormHeading, Well } from '../../../form';
import VisitorTypeForm from '../form';
import createVisitorType from './createVisitorType';
import schema from './schema';

const initialValues: IVisitorTypeFormValues = {
  id: 0,
  name: '',
  icon: 'user',
};

export const CreateVisitorTypePage: React.FC = () => {
  const history = useHistory();

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Visitor Type"
          subTitle="Create"
          backPath="/admin/visitorTypes"
        />
        <Form
          initialValues={initialValues}
          promise={createVisitorType}
          validationSchema={schema}
          onSubmit={() => history.push('/admin/visitorTypes')}
        >
          <VisitorTypeForm />
        </Form>
      </Well>
    </Container>
  );
};
